'use client'

import React from 'react'

import homePageStyle from '../../styles/components/homePage/home_page'
import borderLessCard from '../../styles/components/homePage/topStories/borderless_card'
import dynamicCard from '../../styles/components/homePage/topStories/dynamic_card'
import heroCard from '../../styles/components/homePage/topStories/hero_card'
import mediumCard from '../../styles/components/homePage/topStories/medium_card'
import rightAlignedCard from '../../styles/components/homePage/topStories/right_aligned_card'
import smallCard from '../../styles/components/homePage/topStories/small_card'
import Card from '../Category/Card'
import Title from './Title'

const configureProps = (index, isMobileScreen, withoutBorder) => {
  if (isMobileScreen && withoutBorder) {
    return { style: borderLessCard }
  }

  if (isMobileScreen) {
    return { style: dynamicCard }
  }

  switch (index) {
    case 0:
      return { style: heroCard, isHeroCard: true }
    case 1:
    case 2:
      return { style: mediumCard }
    case 3:
      return { style: rightAlignedCard, isHeroCard: true }
    case 4:
    case 5:
    case 6:
      return { style: smallCard }
  }
}

const TopStories = ({ isMobileScreen, topStories, title = 'Top Stories', withoutBorder = false }) => (
  <div className='top-stories'>
    <Title title={title} />
    {topStories?.map((story, index) => {
      return <Card {...configureProps(index, isMobileScreen, withoutBorder)} story={story} key={story.id} />
    })}
    <style jsx>{dynamicCard}</style>
    <style jsx>{heroCard}</style>
    <style jsx>{mediumCard}</style>
    <style jsx>{rightAlignedCard}</style>
    <style jsx>{smallCard}</style>
    <style jsx>{homePageStyle}</style>
  </div>
)

export default TopStories
